import {createContext, useContext, useMemo, useState, type ReactNode} from 'react';

type BreadcrumbPageTitleContextValue = {
	title: string | null;
	setTitle: (title: string | null) => void;
	trailing: ReactNode | null;
	setTrailing: (trailing: ReactNode | null) => void;
};

const BreadcrumbPageTitleContext = createContext<BreadcrumbPageTitleContextValue | null>(
	null,
);

export function BreadcrumbPageTitleProvider({children}: {children: ReactNode}) {
	const [title, setTitle] = useState<string | null>(null);
	const [trailing, setTrailing] = useState<ReactNode | null>(null);
	const value = useMemo(
		() => ({title, setTitle, trailing, setTrailing}),
		[title, trailing],
	);
	return (
		<BreadcrumbPageTitleContext.Provider value={value}>
			{children}
		</BreadcrumbPageTitleContext.Provider>
	);
}

export function useBreadcrumbPageTitle() {
	const context = useContext(BreadcrumbPageTitleContext);
	if (!context) {
		throw new Error('useBreadcrumbPageTitle must be used within BreadcrumbPageTitleProvider');
	}
	return context;
}
